var render = function render(){var _vm=this,_c=_vm._self._c;return _c('installations',{key:_vm.key,attrs:{"allinstallations":_vm.installations,"completeinstalls":_vm.completeInstalls,"incompleteinstalls":_vm.incompleteInstalls,"isloading":_vm.isLoading}})
}
var staticRenderFns = []

export { render, staticRenderFns }